<template>
  <el-card shadow="hover">
    <div style="padding: 10px 20px">
      <div style="margin-top: 20px; margin-bottom: 10px">请选择导出门店</div>
      <customer-store-select
        :defaultFirst="true"
        :disabled="batchExportSubmit"
        style="width: 180px"
        v-model="storeGuid"
        placeholder="门店"
      />
      <div style="margin-top: 20px; margin-bottom: 10px">请选择导出时间段</div>
      <time-range
        style="margin-bottom: 10px"
        :disabled="batchExportSubmit"
        @change="handleTimeChange"
      />
      <template v-if="storeGuid && times">
        <div v-if="batchExportSubmit">
          <span>
            <i class="el-icon-loading"></i>
            正在导出数据中，请勿离开此页面
          </span>
        </div>
        <div v-else>
          <div style="margin-right: 10px">
            <el-button size="small" type="primary" @click="batchExportSubmitClick">
              导出
            </el-button>
          </div>
        </div>
      </template>
      <div style="line-height: 22px; margin-top: 20px">
        <div>
          <span style="font-weight: 500"> 批量导出操作须知 </span>
        </div>
        <div>
          <span> 1，导出更新处理时间较长，请耐心等待，请勿中途关闭或退出当前界面 </span>
        </div>
        <div>
          <span> 2，导出完成后及时检查导出文件的完整性和准确性 </span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import timeRange from "../../../../components/timeRange.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";

export default {
  components: {
    timeRange,
    customerStoreSelect,
  },
  data() {
    return {
      times: null,
      storeGuid: "",
      batchExportSubmit: false,
    };
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
  },
  methods: {
    handleTimeChange(time) {
      this.times = time;
    },
    batchExportSubmitClick() {
      this.batchExportSubmit = true;
      this.requestApi(
        "biz.warehouse.order.info.export",
        Object.assign(
          {
            storeGuid: this.storeGuid,
          },
          this.times || {}
        ),
        { showError: true, download: true }
      ).finally(() => {
        this.batchExportSubmit = false;
      });
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
  },
};
</script>
